import firebase from "firebase";
import jwt_decode from "jwt-decode";

const firebaseConfig = {
  // Your credentials
  apiKey: "AIzaSyAD6Zakp1yBE5PyDQSmnE4YkhrbDQEHyMo",
  authDomain: "seekho-c084b.firebaseapp.com",
  databaseURL: "https://seekho-c084b.firebaseio.com",
  projectId: "seekho-c084b",
  storageBucket: "seekho-c084b.appspot.com",
  messagingSenderId: "636813832662",
  appId: "1:636813832662:web:883a13b27170e592fc7477",
  measurementId: "G-PY0HJTCNDM",
};

if (!firebase.apps.length) {
  firebase.initializeApp(firebaseConfig);
} else {
  firebase.app(); // if already initialized, use that one
}

const auth = firebase.auth();
const currentFirebaseUser = auth?.currentUser; //user created using firebase
const googleProvider = new firebase.auth.GoogleAuthProvider();

const getCurrentUser = async () => {
  const currentUser = auth.currentUser;
};
const signInWithGoogle = (
  callback_setOpen,
  callback_addUserInGlobalState,
  callback_setShowMenuLinks
) => {
  const status = auth
    .signInWithPopup(googleProvider)
    .then((result) => {
      const user = { accessToken: "", uid: "" };
      result.user?.getIdToken().then((data) => (user.accessToken = data));
      callback_addUserInGlobalState({
        accessToken: user.accessToken,
        uid: result?.user.uid,
      });
      localStorage?.setItem(
        "user",
        JSON.stringify({
          accessToken: user.accessToken,
          uid: result?.user.uid,
        })
      );

      localStorage?.setItem(
        "token",
        JSON.stringify({
          accessToken: user.accessToken,
        })
      );

      callback_setOpen(false);
      callback_setShowMenuLinks(false);
    })

    .catch((error) => {
      console.log("ERROR!! signInWithGoogle", error.message);
      alert(error.message);
    });
};
export { firebase, auth, signInWithGoogle, currentFirebaseUser };
